<ng-container *ngIf="phaseId != null">
    <div class="barra">
        <options class="show-label" [optionstrip]="options" (clickOption)="clickOption($event)"></options>
        <actions [actionstrip]="actions" (clickAction)="clickAction($event)">
        </actions>
    </div>
  
    <shared-route-part-cmr-maintenance [routePartCMR]="selectedRoutePartCMR" [readonly]="readonly"
        (routePartCMRUpdated)="onRoutePartCMRUpdated($event)" (refreshRoutePartCMR)="onRefreshRoutePartCMR($event)"
        (refreshRoute)="loadRouteData()">
    </shared-route-part-cmr-maintenance>
    
</ng-container>